import { toSnakeCase } from "Library/Utils";
import { useTranslation } from "react-i18next";

export const useTranslationCheck = () => {
  const { t } = useTranslation();

  const translationCheck = (text: string) => {
    if (!text) return text;

    const base = text.toLowerCase();

    const attempts = [
      text,
      base,
      toSnakeCase(base),
    ];

    for (const key of attempts) {
      const result = t(`Translation.${key}`);
      if (!result.includes("Translation.")) return result;
    }

    return text;
  };

  return { t, tCheck: translationCheck };
};
